import * as React from "react";
import { AppProps } from "next/app";
import { AnydoSentry } from "@anydo/vendor/sentry";
import { AnalyticsProviderNoop } from "@anydo/analytics-react/test-utils";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { AppAuthProvider } from "@/components/auth/AppAuthProvider";
import "@/styles/globals.css";
import { GoogleTagManager } from "@next/third-parties/google";
import { GTM_ID } from "@/lib/config";

if (typeof window !== "undefined") {
  try {
    AnydoSentry.init({
      app_os: "browser",
      app_platform: "browser",
      app_window: "browser",
    });
  } catch {
    // Sentry init fails in dev when REACT_APP_SENTRY_ENVIRONMENT is not set
  }
}

const App: React.FC<AppProps> = ({ Component, pageProps }) => {
  return (
    <>
      <AnalyticsProviderNoop>
        <LanguageProvider>
          <AppAuthProvider>
            <Component {...pageProps} />
          </AppAuthProvider>
        </LanguageProvider>
      </AnalyticsProviderNoop>
      <GoogleTagManager gtmId={GTM_ID} />
    </>
  );
};

export default App;
